import { css, cva } from "styled-system/css";

export { pageContainerStyles as pageStyles, pageHeaderStyles as headerStyles } from "#/app.css";

export const titleStyles = css({
  fontFamily: "sans",
  fontWeight: "900",
  letterSpacing: "-0.025em",
  color: "textBase",
  fontSize: "h2",
});

export const sourceListStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "xs",
});

export const actionBtnStyles = css({
  cursor: "pointer",
  transition: "all 200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingInline: "md",
  paddingY: "sm",
  backgroundColor: "primary",
  color: "primaryContent",
  borderRadius: "medium",
  fontWeight: "900",
  textTransform: "uppercase",
  fontSize: "xs",
  letterSpacing: "0.1em",
});

export const loadingStyles = css({
  paddingY: "xxl",
  textAlign: "center",
  fontWeight: "700",
  color: "textBase/60",
});

export const emptyStyles = css({
  paddingY: "xxl",
  textAlign: "center",
  fontWeight: "700",
  color: "textBase/60",
});

export const sourceItemStyles = cva({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "sm",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: "bgBase300",
    backgroundColor: "transparent",
    transition: "background-color 200ms",
    _hover: {
      backgroundColor: "bgBase200",
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 0.5,
      },
    },
  },
});

export const sourceTitleStyles = css({
  fontSize: "sm",
  fontWeight: "600",
  color: "textBase",
  display: "flex",
  alignItems: "center",
  gap: "xs",
});

export const sourceLinkStyles = css({
  color: "textBase/40",
  transition: "color 200ms",
  _hover: {
    color: "primary",
  },
});

/* Dropdown Menu */
export const dropdownContainerStyles = css({
  position: "relative",
});

export const dropdownMenuStyles = css({
  position: "absolute",
  right: 0,
  top: "100%",
  marginTop: "xs",
  zIndex: 50,
  minWidth: "12rem",
  backgroundColor: "bgBase100",
  borderRadius: "medium",
  boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  padding: "xs",
  overflow: "hidden",
});

export const dropdownItemStyles = cva({
  base: {
    display: "flex",
    alignItems: "center",
    gap: "sm",
    width: "100%",
    padding: "sm",
    fontSize: "sm",
    color: "textBase",
    cursor: "pointer",
    borderRadius: "small",
    transition: "background-color 150ms",
    _hover: {
      backgroundColor: "bgBase200",
    },
  },
  variants: {
    danger: {
      true: {
        color: "error",
        _hover: {
          backgroundColor: "error/10",
        },
      },
    },
  },
});

/* Modal */
export const modalOverlayStyles = css({
  position: "fixed",
  inset: 0,
  zIndex: 100,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "md",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  backdropFilter: "blur(4px)",
});

export const modalBoxStyles = css({
  width: "100%",
  maxWidth: "42rem",
  overflow: "hidden",
  backgroundColor: "bgBase100",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "color-mix(in srgb, {colors.textBase}, transparent 90%)",
  borderRadius: "xlarge",
  boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)",
});

export const modalHeaderStyles = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "lg",
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: "bgBase300",
});

export const modalTitleStyles = css({
  fontSize: "h3",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "-0.025em",
});

export const modalBodyStyles = css({
  padding: "lg",
  display: "flex",
  flexDirection: "column",
  gap: "md",
});

export const importTextareaStyles = css({
  width: "100%",
  height: "16rem",
  padding: "md",
  fontFamily: "mono",
  fontSize: "xs",
  backgroundColor: "bgBase200",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase200",
  borderRadius: "large",
  outline: "none",
  color: "textBase",
  _focus: {
    borderColor: "primary",
  },
});

export const modalActionsStyles = css({
  display: "flex",
  gap: "md",
});

export const modalBtnStyles = cva({
  base: {
    cursor: "pointer",
    transition: "all 200ms",
    userSelect: "none",
    border: "none",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    paddingY: "sm",
    borderRadius: "medium",
    fontWeight: "900",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: "inherit",
  },
  variants: {
    primary: {
      true: {
        backgroundColor: "primary",
        color: "primaryContent",
      },
    },
  },
});
